import React, { Component } from 'react';
import Button from '../Button/index';

const AddActivity = (props) => (
    <div className="content-layout content-layout__wide content-layout_collapse">
        <div className="large-wrap justifycentre add-activity-container">
            <h3>Add a listing</h3>
            <p>Know something we don't? Please let us know about your activity so we can consider its inclusion in our LiveWell Finder.</p>
            <Button
                type="button"
                label="add a listing"
                classes="button-round button__primary-purple"
                id="add-activity-button"
                onClick={() => { window.location = '/new-activity/'; }}
            />
        </div>
    </div>
);

export default AddActivity;
